// extracted by mini-css-extract-plugin
module.exports = {"baseBanner":"BaseBanner_baseBanner_MhQxX","isStyleB":"BaseBanner_isStyleB_2Js_A","isStyleA":"BaseBanner_isStyleA_3qxDM"};